import { render, staticRenderFns } from "./form.vue?vue&type=template&id=849f5704&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('849f5704')) {
      api.createRecord('849f5704', component.options)
    } else {
      api.reload('849f5704', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=849f5704&", function () {
      api.rerender('849f5704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/todo/form.vue"
export default component.exports